import type { ContextMenu } from 'components/move-list/components/context-menu/config/types';
import type { Store, StoreActions } from 'components/move-list/store/types';
import { MoveList } from 'chessboard/model/move-list/types';
import { CONTEXT_MENU_ACTION_NAMES } from '../config/context-menu-action-names';

/**
 * Create DeleteVariation action
 */
export function createDeleteCommentBefore(
  store: Store,
  _storeActions: StoreActions,
): ContextMenu.Action {
  return {
    getDisplayName: () => MoveList.Translation.Actions.DeleteCommentBefore,
    action: CONTEXT_MENU_ACTION_NAMES.DeleteCommentBefore,
    isVisible,
    handler,
  };

  /**
   * visible only when initComment is present and is first node
   */
  function isVisible({ node, game }: ContextMenu.ActionHandlerContext) {
    const lines = game.getRawLines();
    const line = lines[node.ids.line];
    const initCommentExists = line.initComment !== undefined;
    const isFirstNode = node.ids.move === 0;
    const isEditable = store.commentsEditable.get();

    return initCommentExists && isFirstNode && isEditable;
  }

  /**
   * handler to delete comment after node
   */
  function handler({ node, game }: ContextMenu.ActionHandlerContext): void {
    game.updateLineComment(undefined, node.ids.line);
  }
}
